import React, { useState } from 'react'
import _ from 'lodash'
import classNames from 'classnames'
import { SaveItem } from '../../../utils/appdata'
import { ReactComponent as Spinner } from '../../../images/icons/spinner.svg'

const MutationButton = ({
                          def,
                          queryStatus,
                          context,
                          childContext,
                          spaceRight,
                          spaceLeft,
                        }) => {

  const [loadingSave, setLoadingSave] = useState(false)

  const saveMutation = async (query, newValue, origValue, debugDiffs) => {
    if (debugDiffs && debugDiffs.length) {
      for (const diffObj of debugDiffs) {
        console.log(JSON.stringify(diffObj))
      }
      console.log('origValue:')
      console.log(origValue)
      console.log('newValue:')
      console.log(newValue)
      return
    }
    try {
      setLoadingSave(true)
      const mutatedData = await SaveItem(query, query.keyName, context, context.instanceId, newValue, origValue)
      if (mutatedData && !_.isEqual(mutatedData, origValue)) {
        // now that changes have been saved, update data locally to reflect what was returned by the server
        const keyNameHack = (def.provider === 'Knackly' && def.keyName === '_id') ? 'id$' : def.keyName
        const effectiveContext = childContext || context
        if (def.mapTo) {
          effectiveContext.linkMappedObjectValue(mutatedData, def.typeName, keyNameHack, def.mapTo)
        } else {
          effectiveContext.linkSimpleObjectValue(mutatedData, def.typeName, keyNameHack)
        }
      }
    } catch (e) {
      console.log(e)
    } finally {
      setLoadingSave(false)
    }
  }

  const enabled = queryStatus.hasVal && queryStatus.hasMods
  const label = queryStatus.hasMods
    ? `Save to ${queryStatus.queryDef.label}`
    : '(up to date)'
  const buttonClasses = classNames('btn btn-outline-secondary dart-btn-outline',
    { 'mr-3': spaceRight, 'ml-3': spaceLeft })

  return (
    <button className={buttonClasses}
            style={{ backgroundColor: '#FFFFFF' }}
            onClick={(e) => {
              saveMutation(
                queryStatus.queryDef,
                queryStatus.value,
                queryStatus.origValue,
                e.shiftKey && queryStatus.diffs,
              )
            }}
            disabled={!enabled || loadingSave}>{loadingSave ? (<Spinner className={'rot'} style={{
      width: 25,
      top: -4,
      position: 'relative',
    }}/>) : label}</button>
  )
}

export default MutationButton
